document.addEventListener("DOMContentLoaded", function () {
  const menu = document.querySelector(".mini-menu-popup-menu");

  if (!menu) return;

  document.addEventListener("click", function (event) {
    const isClickInside = menu.contains(event.target);

    if (isClickInside) {
      menu.setAttribute("open", "");
    } else {
      menu.removeAttribute("open");
    }
  });
});